module.exports = __webpack_public_path__ + "img/multiplier_8_en.b31c1d50.png";